export enum SearchFormField {
  INITIAL = 'initial',
  DESTINATION = 'destination',
  DATES = 'dates',
  EVENT_TYPE = 'eventType',
  SEARCH_FORM_FULL = 'searchFormFull',
}
